export const banners = (state) => state.banners
